import uniqueId from 'lodash/uniqueId';

import { prepareBannerImage, TImageConfig } from '.';

type TTextInfo = {
    title: React.ReactNode,
    description: React.ReactNode,
}

const prepareWideSmallBanner = ({ section, category }: Omit<TImageConfig, 'name' | 'extension'>) => ({ title, description }: TTextInfo, name: number) => ({
    key: uniqueId(),
    backgroundImage: prepareBannerImage({
        section,
        category,
        name,
        extension: 'png',
    }),
    backgroundImageWebp: prepareBannerImage({
        section,
        category,
        name,
        extension: 'webp',
    }),
    title,
    description,
});

export default prepareWideSmallBanner;
